import { ScorecardReport } from '../components/ScorecardReport';

/**
 * The Service Desk scorecard — the library items that belong to the Service
 * Desk unit, with the figures Autotask can give
 * (api/src/lib/serviceDeskScorecard.ts). The report itself is shared with the
 * NOC and CS pages: components/ScorecardReport.tsx.
 */
export function ServiceDeskScorecard() {
  return (
    <ScorecardReport
      path="/service/scorecard"
      team="Service Desk"
      filePrefix="service-desk-scorecard"
      caption={(from, to) =>
        `Figures are live from Autotask: tickets, time entries, surveys, projects and service calls from ${from} to ${to}.`
      }
    />
  );
}
